import { Box, Skeleton, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { customerStatsMessages } from "./messages";

interface CustomerStatsCardsProps {
  totalCustomers: number | undefined;
  loading: boolean;
}

export const CustomerStatsCards = ({
  totalCustomers,
  loading,
}: CustomerStatsCardsProps) => {
  const intl = useIntl();

  return (
    <Box display="grid" __gridTemplateColumns="repeat(3, 1fr)" gap={3} paddingX={6} paddingY={3}>
      <Box
        borderWidth={1}
        borderStyle="solid"
        borderColor="default1"
        borderRadius={3}
        paddingX={4}
        paddingY={4}
        display="flex"
        flexDirection="column"
        gap={1}
        data-test-id="customer-stats-total"
      >
        <Text size={2} color="default2">
          {intl.formatMessage(customerStatsMessages.totalCustomers)}
        </Text>
        <Text size={8} fontWeight="bold">
          {loading || totalCustomers === undefined ? (
            <Skeleton __width="60px" />
          ) : (
            totalCustomers.toLocaleString()
          )}
        </Text>
      </Box>
    </Box>
  );
};
